export default "__VITE_ASSET__509531b6__"